export default "__VITE_ASSET__CNgTf4QW__"